import React from "react";
import { createRoot } from "react-dom/client";
import LoginSignup from "./components/LoginSignup";

document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("login-signup-page");

  if (container) {
    console.log("Element found, initializing React app...");
    const root = createRoot(container);
    root.render(<LoginSignup />);
  } else {
    console.error("Element with id 'login-signup-page' not found.");
  }
});
